import { createTheme, alpha } from '@mui/material/styles';

// Single source of truth for the app's visual language.
export const BRAND = {
  name: 'TaskFlow',
  tagline: 'Task management, time tracking and an AI assistant — in one place.',
};

const PRIMARY = '#4F46E5'; // indigo
const SECONDARY = '#0EA5E9'; // sky
const SIDEBAR_BG = '#101322';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: PRIMARY, light: '#818CF8', dark: '#3730A3' },
    secondary: { main: SECONDARY },
    success: { main: '#16A34A' },
    warning: { main: '#D97706' },
    error: { main: '#DC2626' },
    background: {
      default: '#F4F5FA',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#1F2333',
      secondary: '#5A6072',
    },
    divider: '#E5E7F0',
  },
  shape: {
    borderRadius: 10,
  },
  typography: {
    fontFamily:
      '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    h4: { fontWeight: 700, letterSpacing: '-0.02em' },
    h5: { fontWeight: 700, letterSpacing: '-0.01em' },
    h6: { fontWeight: 600 },
    subtitle1: { fontWeight: 600 },
    subtitle2: { fontWeight: 600 },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: { borderRadius: 8 },
        containedPrimary: {
          '&:hover': { backgroundColor: '#4338CA' },
        },
      },
    },
    MuiCard: {
      defaultProps: { elevation: 0 },
      styleOverrides: {
        root: {
          border: '1px solid #E5E7F0',
          borderRadius: 14,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: 'none' },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: { borderRadius: 14 },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { fontWeight: 600 },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: { fontSize: 12 },
      },
    },
    MuiTextField: {
      defaultProps: { variant: 'outlined' },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          backgroundColor: '#FFFFFF',
        },
      },
    },
  },
});

export const sidebarTokens = {
  background: SIDEBAR_BG,
  itemColor: '#9AA1B5',
  itemHoverBg: alpha('#FFFFFF', 0.06),
  itemActiveColor: '#FFFFFF',
  itemActiveBg: alpha(PRIMARY, 0.45),
  width: 248,
};

export default theme;
